import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { Specification, SpecificationStructure } from "../models/specification.model";
import { ConfigService } from "../../core/services/config.service";

@Injectable({
  providedIn: 'root',
})
export class SpecificationService {

  constructor(private http: HttpClient, private configService: ConfigService) { }

  getSpecificationStructure(): Observable<SpecificationStructure> {
    return this.http.get<SpecificationStructure>(`${this.configService.apiUrl}specificationstructure`);
  }

  getFamilies(): Observable<SpecificationStructure> {
    return this.http.get<SpecificationStructure>(this.configService.apiUrl + 'specificationstructure/compact');
  }

  getSpecifications(): Observable<Specification[]> {
    return this.http.get<Specification[]>(`${this.configService.apiUrl}specifications`);
  }

}  